import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlaybookListQuery$variables } from './__generated__/PlaybookListQuery.graphql';
import PlaybookListQuery$parameters from './__generated__/PlaybookListQuery$parameters';

export const playbookListEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(/* webpackChunkName: "async-playbooks-list" */ './PlaybookList').then(
			(module) => module.PlaybookList,
		),
	),
	getPreloadProps: (variables: PlaybookListQuery$variables) => {
		return {
			queries: {
				PlaybookListQuery: {
					parameters: PlaybookListQuery$parameters,
					variables,
				},
			},
		};
	},
});
